import { render, staticRenderFns } from "./AddNotification.vue?vue&type=template&id=4218c7f2&scoped=true"
import script from "./AddNotification.vue?vue&type=script&lang=js"
export * from "./AddNotification.vue?vue&type=script&lang=js"
import style0 from "./AddNotification.vue?vue&type=style&index=0&id=4218c7f2&prod&scoped=true&lang=css"
import style1 from "./AddNotification.vue?vue&type=style&index=1&id=4218c7f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4218c7f2",
  null
  
)

export default component.exports